.cy{padding:0.5rem;}